<template lang="html">
  <d-button-group class="buttons">
    <d-dropdown text="Enviar" theme="info">
      <span class="dropdown-item" @click.prevent="openModal('send_quotation_modal')" :disabled="!this.quotation.customer.email">
        <i class="fas fa-envelope"></i><span class="d-none d-lg-inline"> E-mail</span>
      </span>
      <span class="dropdown-item" @click.prevent="openModal('send_whats_quotation_modal')" :disabled="!this.quotation.customer.phone">
        <i class="fab fa-whatsapp"></i><span class="d-none d-lg-inline"> Whatsapp</span>
      </span>
    </d-dropdown>
    <d-dropdown text="Imprimir">
      <span class="dropdown-item">
        <i class="fas fa-print"></i><span class="d-inline" @click.prevent="printQuotation()"> Orçamento</span>
      </span>
      <span class="dropdown-item">
        <i class="fas fa-print"></i><span class="d-inline" @click.prevent="openModal('print_warranty_modal')"> Garantia</span>
      </span>
      <span class="dropdown-item">
        <i class="fas fa-industry"></i><span class="d-inline" @click.prevent="openModal('print_manufacture_modal')"> Fabricação</span>
      </span>
    </d-dropdown>
    <d-button size="sm" class="btn-secondary" @click.prevent="duplicate()">
      <i class="fas fa-copy"></i><span class="d-none d-lg-inline"> Duplicar</span>
    </d-button>
    <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
      <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
    </d-button>
  </d-button-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import { _OPEN_MODAL_, _LOAD_MODEL_, _DELETE_QUOTATION_ } from '_modules/quotation/components/QuotationModel';
import { openPdf, catchPdf } from '_utils/require';

export default {
  name: 'quotation-buttons',
  props: {
    quotation: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_QUOTATION_, this.quotation);
    },
    duplicate() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.duplicate(this.quotation.id)
        .then(response => {
          this.activeAlert({ message: 'Orçamento duplicado com sucesso', theme: 'success' });
          Events.$emit(_LOAD_MODEL_, response);
          this.$router.push(`/admin/orcamentos/${response.id}`);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    printQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.print(this.quotation.id)
        .then(response => openPdf(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    openModal(type = 'print_warranty_modal') {
      this.setToggle({ type, bool: true });
      Events.$emit(_OPEN_MODAL_, { quotation: this.quotation, type });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
